<template>
  <div class="page-ReserCard">
    <div class="ReserCard_head">
      <p>
        <img class="icon" :src="img" alt />
        日期：{{ startTime }}
      </p>
    </div>
    <div class="ReserCard_content">
      <div
        class="ReserCard_content_actName child"
        :class="isTicket ? '' : 'grid_three'"
      >
        活动名称:{{ act_name }}
      </div>
      <div class="child" v-if="isTicket">检票状态:{{ status }}</div>
      <div class="child">姓名：{{ username }}</div>
      <div class="child">手机号:{{ phone }}</div>
      <div class="child grid_three" v-if="isTicket">身份证:{{ idCard }}</div>
      <div></div>
      <div class="child cancel" @click="hanldeClick">取消预约</div>
    </div>
    <div
      style="
        width: calc(100% - 32px);
        margin: 0px auto;
        height: 0.5px;
        border-bottom: 0.5px solid rgb(235, 237, 240);
      "
    ></div>
  </div>
</template>

<script>
import image from "@lib/image/personalCenter/mobile_tuan.png";
export default {
  name: "ReserCard",
  props: {
    isTicket: {
      type: Boolean,
      required: true,
    },
    startTime: {
      type: String,
      required: false,
    },
    act_name: {
      type: String,
      required: false,
    },
    username: {
      type: String,
      required: false,
    },
    phone: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    idCard: {
      type: String,
      required: false,
    },
    hanldeSkip: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      img: image,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    hanldeClick() {
      if (this.isTicket) {
        this.hanldeSkip && this.unreser_ticket();
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-ReserCard {
  .ReserCard_head {
    color: #666666;
    height: 46px;
    line-height: 46px;
    padding: 0 20px;
    background: #fff;

    .icon {
      // width: 16px;
      height: 18px;
      margin-right: 6px;
      transform: translateY(-1px);
    }
  }
  .ReserCard_content {
    height: ~"calc(100% - 50px - 54px)";
    font-size: 14px;
    padding: 0px 22px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    color: #666666;
    line-height: 20px;
    background: #eef9fa;

    .child {
      height: 40px;
      line-height: 40px;
    }
    .cancel {
      color: #1e52a0;
      text-decoration: underline;
      text-align: right;
    }
    .grid_three {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
  .yello {
    background: #fef9f3;
  }
}
</style>